<template>
    <div class="upload-avatar">
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>Drop files to upload</h3>
        </div>
        <div class="avatar-upload"  v-show="!edit">
            <div class="text-center p-2">
                <label class="avatar-upload-label" for="file">
                    <img :src="imgUrl" class="rounded-circle" />
                </label>
            </div>
            <div class="file-uploader-hidden">
                <file-upload
                    extensions="gif,jpg,jpeg,png,webp"
                    accept="image/png,image/gif,image/jpeg,image/webp"
                    name="file"
                    class="btn btn-primary"
                    :multiple="false"
                    :drop="!edit"
                    v-model="files"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    :custom-action="onUploadFile"
                    ref="upload">
                Upload
                </file-upload>
            </div>
        </div>

        <div class="avatar-edit" v-show="files.length && edit">
            <div class="avatar-edit-image" v-if="files.length">
                <img ref="editImage" :src="files[0].url" />
            </div>
            <div class="text-center p-4">
                <vs-button type="border" color="primary" @click.prevent="$refs.upload.clear">Cancel</vs-button>&nbsp;
                <vs-button type="filled" color="primary" @click.prevent="editSave">Save</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
    import Cropper from 'cropperjs'
    import FileUpload from 'vue-upload-component'

    export default {
        name: 'Avatar',
        props: [ 'url', 'onUploadFile' ],
        components: {
            FileUpload,
        },
        data() {
            return {
                imgUrl: this.url,
                files: [],
                edit: false,
                cropper: false
            }
        },
        watch: {
            url(value) {
                this.imgUrl = value;
            },

            edit(value) {
                if (value) {
                    this.$nextTick(function () {
                        if (!this.$refs.editImage) {
                            return
                        }
                        let cropper = new Cropper(this.$refs.editImage, {
                            aspectRatio: 1 / 1,
                            viewMode: 1,
                        })
                        this.cropper = cropper
                    })
                } else {
                    if (this.cropper) {
                        this.cropper.destroy()
                        this.cropper = false
                    }
                }
            }
        },
        methods: {
            editSave() {
                this.edit = false
                let oldFile = this.files[0]
                let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1])
                let arr = new Uint8Array(binStr.length)
                for (let i = 0; i < binStr.length; i++) {
                    arr[i] = binStr.charCodeAt(i)
                }
                let file = new File([arr], oldFile.name, { type: oldFile.type })
                this.$refs.upload.update(oldFile.id, {
                    file,
                    type: file.type,
                    size: file.size,
                    active: true,
                })
            },
            alert(message) {
                this.$vs.notify({
                    color: "warning",
                    title: 'Warning',
                    text: message
                });
            },
            inputFile(newFile, oldFile/*, prevent*/) {
                if (newFile && !oldFile) {
                    this.$nextTick(function () {
                        this.edit = true
                    })
                }
                if (!newFile && oldFile) {
                    this.edit = false
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
                        this.alert('Your choice is not a picture')
                        return prevent()
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    newFile.url = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                        newFile.url = URL.createObjectURL(newFile.file)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    @import "https://cdn.jsdelivr.net/npm/cropperjs/dist/cropper.css"
</style>
<style lang="scss">
    .avatar-upload-label {
        cursor: pointer;
    }
    .avatar-edit-image {
        max-width: 100%;
        max-height: 600px;
    }
    .file-uploader-hidden {
        display: none;
    }
    .upload-avatar .avatar-upload .rounded-circle {
        width: 150px;
        height: 150px;
        border: 1px solid #e8e8e8;
    }
    .upload-avatar .text-center .btn {
        margin: 0 .5rem
    }
    .upload-avatar .avatar-edit-image {
        max-width: 100%
    }
    .upload-avatar .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }
    .upload-avatar .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
</style>
